<template lang="pug">
  v-app
    v-toolbar.secondary(flat, app, dark, dense)
      v-toolbar-side-icon(@click="drawer = !drawer")
      v-toolbar-title {{$route.name}}
      v-spacer
      v-toolbar-items
        v-btn(flat, @click="$router.push('/app/')", v-if="$route.name !== 'Administración'")
          span.hidden-sm-and-down DASHBOARD
          v-icon(right) dashboard
        v-btn(flat, @click="out")
          span.hidden-sm-and-down salir
          v-icon(right) exit_to_app
    v-navigation-drawer(app, v-model="drawer", disable-resize-watcher)
      Menu(:menu="menuItems", @clickMenu="drawer = false")
    router-view
</template>

<script>
import Menu from '../shared/Menu'
export default {
  components: {
    Menu
  },
  data () {
    return {
      drawer: false,
      menuItems: [
        {iconClass: '', icon: 'home', texto: 'Inicio', ruta: '/app'},
        {iconClass: '', icon: 'view_module', texto: 'Catálogo', ruta: '/app/catalogo'},
        {iconClass: '', icon: 'assignment', texto: 'Cotizaciones', ruta: '/app/cotizaciones'},
        {iconClass: '', icon: 'monetization_on', texto: 'Ventas', ruta: '/app/ventas'},
        {iconClass: '', icon: 'loyalty', texto: 'Reservas', ruta: '/app/reservas'},
        {iconClass: '', icon: 'bookmark', texto: 'Colecciones', ruta: '/app/colecciones'},
        {iconClass: '', icon: 'person', texto: 'Clientes', ruta: '/app/clientes'},
        {iconClass: '', icon: 'mail', texto: 'Novedades', ruta: '/app/novedades'},
        {iconClass: '', icon: 'web', texto: 'Contenidos', ruta: '/app/contenidos'},
        {iconClass: '', icon: 'timeline', texto: 'Estadísticas', ruta: '/app/estadisticas'}
      ]
    }
  },
  methods: {
    out () {
      this.$store.dispatch('usuario/out', this.$store.getters['usuario/user'].uid)
      .then(out => {
        if (out)
          this.$router.push('/')
      })
    }
  }
}
</script>

<style>

</style>
